/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import SelectQuestion from '../../components/mobile/feedback/SelectQuestion.js';
import TextAreaQuestion from '../../components/mobile/feedback/TextAreaQuestion.js';
import InputRate from '../../components/mobile/feedback/InputRate.js';

const mobileFeedbackRoutes = [
  {
    id: '1',
    path: '/feedback/call-with-doctor',
    component: (props) => <SelectQuestion {...props} />,
    props: {
      fieldName: 'call_with_doctor',
      isFirst: true,
      prevRoutePath: '',
      nextRoutePath: '/feedback/what-we-improve-next-time',
      question: 'feedback:question1.question',
      options: [
        {
          value: 'option 1',
          label: 'feedback:question1.option1',
        },
        {
          value: 'option 2',
          label: 'feedback:question1.option2',
        },
        {
          value: 'option 3',
          label: 'feedback:question1.option3',
        },
      ],
      boxWidth: '320px',
      bodyStyle: {
        paddingTop: '20px',
        paddingBottom: '33px',
      },
    },
  },
  {
    id: '2',
    path: '/feedback/what-we-improve-next-time',
    component: (props) => <TextAreaQuestion {...props} />,
    props: {
      fieldName: 'what_imporove',
      prevRoutePath: '/feedback/call-with-doctor',
      nextRoutePath: '/feedback/leave-rating',
      question: 'feedback:question2.question',
    },
  },
  {
    id: '3',
    path: '/feedback/leave-rating',
    component: (props) => <InputRate {...props} />,
    props: {
      fieldName: 'rating',
      isLastQuestion: true,
      prevRoutePath: '/feedback/what-we-improve-next-time',
      nextRoutePath: '',
      question: 'feedback:question3.question',
    },
  },
];

export const getMobileFeedbackRoutes = () => mobileFeedbackRoutes;
